(function () {
    /* global AOS, Swiper */
    if (typeof AOS !== 'undefined' && AOS && typeof AOS.init === 'function') {
        AOS.init();
    }

    const SELECTORS = {
        introSection: '.ap-section__intro',
        introCta: '.ap-section__intro .ap-section__cta-btn',
        introVideo: '.ap-section__intro .ap-video video',
        products: '.ap-products',
        productsPagination: '.ap-products .swiper-pagination',
        productsNext: '.ap-products__navigation .swiper-button-next',
        productsPrev: '.ap-products__navigation .swiper-button-prev',
        contentsBox: '.contents-box',
        giftVideo: '.gift-video',
        playButton: '.play-btn',
        post: '.ap-post--sulwhasoo-gift',
        swiper: '.ap-swiper',
    };

    const MOBILE_MAX = 750;
    // const CAPTION_CLASSNAMES = {
    //     wrapper: 'ap2022-video-script-box',
    //     header: 'ap2022-video-script-box__header',
    //     button: 'ap2022-video-script-box__button',
    //     toggle: 'ap2022-video-script-box__toggle',
    //     text: 'ap2022-video-script-box__text',
    //     textShow: 'ap2022-video-script-box__text--show',
    //     open: 'is-active',
    // };

    const debounce = function (fn, delay) {
        let timer;
        return function debounced() {
            const args = arguments;
            clearTimeout(timer);
            timer = setTimeout(function () {
                fn.apply(null, args);
            }, delay);
        };
    };

    const videoController = function () {
        const introSection = document.querySelector(SELECTORS.introSection);
        const introCta = document.querySelector(SELECTORS.introCta);
        const introVideo = document.querySelector(SELECTORS.introVideo);
        let activeBox = null;

        const isMobile = function () {
            return window.innerWidth <= MOBILE_MAX;
        };

        const playVideo = function (wrapper, video, { reset } = { reset: false }) {
            if (!wrapper || !video) {
                return;
            }
            if (reset) {
                video.currentTime = 0;
            }
            wrapper.classList.add('is-active');
            video.muted = true;
            video.setAttribute('tabindex', 0);
            video.play().catch(function () {
                // autoplay block 무시
            });
        };

        const pauseVideo = function (wrapper, video, { resetTime } = { resetTime: false }) {
            if (!wrapper || !video) {
                return;
            }
            wrapper.classList.remove('is-active');
            video.pause();
            if (resetTime) {
                video.currentTime = 0;
            }
            video.setAttribute('tabindex', -1);
            const focusTarget = wrapper.querySelector('button, .play-btn, [tabindex]');
            if (focusTarget) {
                focusTarget.focus();
            }
        };

        const hideActiveBox = function () {
            if (!activeBox) {
                return;
            }
            const targetVideo = activeBox.querySelector(SELECTORS.giftVideo);
            pauseVideo(activeBox, targetVideo, { resetTime: true });
            activeBox = null;
        };

        const bindContentsBoxes = function () {
            const boxes = document.querySelectorAll(SELECTORS.contentsBox);
            if (!boxes.length) {
                return;
            }
            boxes.forEach(function (box) {
                const video = box.querySelector(SELECTORS.giftVideo);
                const playBtn = box.querySelector(SELECTORS.playButton);

                const activate = function () {
                    if (activeBox && activeBox !== box) {
                        hideActiveBox();
                    }
                    activeBox = box;
                    playVideo(box, video, { reset: true });
                };

                box.addEventListener('click', activate);

                if (playBtn) {
                    playBtn.addEventListener('keydown', function (event) {
                        const key = event.key;
                        if (key === 'Enter' || key === ' ') {
                            event.preventDefault();
                            activate();
                        } else if (key === 'Tab') {
                            hideActiveBox();
                        }
                    });
                }

                if (video) {
                    video.addEventListener('ended', function () {
                        pauseVideo(box, video, { resetTime: true });
                        activeBox = null;
                    });
                }
            });
        };

        // const setupCaptionToggle = function (wrapper) {
        //     const button = wrapper.querySelector('.' + CAPTION_CLASSNAMES.button);
        //     const toggleArea = wrapper.querySelector('.' + CAPTION_CLASSNAMES.toggle);
        //     const text = wrapper.querySelector('.' + CAPTION_CLASSNAMES.text);
        //
        //     if (!button || !toggleArea || !text) {
        //         return;
        //     }
        //
        //     text.classList.add(CAPTION_CLASSNAMES.textShow);
        //     if (!text.hasAttribute('tabindex')) {
        //         text.setAttribute('tabindex', '0');
        //     }
        //
        //     const setState = function (isOpen) {
        //         wrapper.classList.toggle(CAPTION_CLASSNAMES.open, isOpen);
        //         toggleArea.hidden = !isOpen;
        //         toggleArea.style.maxHeight = isOpen ? toggleArea.scrollHeight + 'px' : '0px';
        //         button.setAttribute('aria-expanded', String(isOpen));
        //         button.title = isOpen ? '닫기' : '열기';
        //     };
        //
        //     setState(false);
        //
        //     button.addEventListener('click', function () {
        //         const willOpen = !wrapper.classList.contains(CAPTION_CLASSNAMES.open);
        //         setState(willOpen);
        //     });
        // };
        //
        // const buildCaption = function (video) {
        //     if (!video) {
        //         return;
        //     }
        //
        //     const container = video.parentElement;
        //     let wrapper = container.querySelector('.' + CAPTION_CLASSNAMES.wrapper);
        //
        //     const ensureStructure = function (targetWrapper) {
        //         let header = targetWrapper.querySelector('.' + CAPTION_CLASSNAMES.header);
        //         let button = targetWrapper.querySelector('.' + CAPTION_CLASSNAMES.button);
        //         let toggleArea = targetWrapper.querySelector('.' + CAPTION_CLASSNAMES.toggle);
        //         let text = targetWrapper.querySelector('.' + CAPTION_CLASSNAMES.text);
        //
        //         if (!header || !button || !toggleArea || !text) {
        //             const srTextNode = container.querySelector('.ap2022-sr-only');
        //             const fallbackHtml = srTextNode ? srTextNode.innerHTML.trim() : '';
        //             const textHtml = text && text.innerHTML ? text.innerHTML.trim() : '';
        //             const captionHtml = textHtml || fallbackHtml;
        //             if (!captionHtml) {
        //                 return null;
        //             }
        //
        //             if (!text) {
        //                 text = document.createElement('div');
        //                 text.className = CAPTION_CLASSNAMES.text;
        //                 text.innerHTML = captionHtml;
        //             } else {
        //                 text.innerHTML = captionHtml || text.innerHTML;
        //             }
        //
        //             header = document.createElement('div');
        //             header.className = CAPTION_CLASSNAMES.header;
        //
        //             button = document.createElement('button');
        //             button.type = 'button';
        //             button.className = CAPTION_CLASSNAMES.button;
        //             button.innerHTML = '<span>자막</span><i></i>';
        //             header.appendChild(button);
        //
        //             toggleArea = document.createElement('div');
        //             toggleArea.className = CAPTION_CLASSNAMES.toggle;
        //             toggleArea.appendChild(text);
        //
        //             targetWrapper.innerHTML = '';
        //             targetWrapper.append(header, toggleArea);
        //         }
        //
        //         targetWrapper.classList.add('ap2022-video-script-box--show', 'ap2022-video-script-box--brown');
        //         targetWrapper.classList.remove(CAPTION_CLASSNAMES.open);
        //         return targetWrapper;
        //     };
        //
        //     if (!wrapper) {
        //         const srTextNode = container.querySelector('.ap2022-sr-only');
        //         const captionHtml = srTextNode ? srTextNode.innerHTML.trim() : '';
        //         if (!captionHtml) {
        //             return;
        //         }
        //         wrapper = document.createElement('div');
        //         wrapper.className = CAPTION_CLASSNAMES.wrapper;
        //         const text = document.createElement('div');
        //         text.className = CAPTION_CLASSNAMES.text;
        //         text.innerHTML = captionHtml;
        //         wrapper.appendChild(text);
        //         container.appendChild(wrapper);
        //     }
        //
        //     const structured = ensureStructure(wrapper);
        //     if (structured) {
        //         setupCaptionToggle(structured);
        //     }
        // };
        //
        // const initCaptions = function () {
        //     if (introVideo) {
        //         buildCaption(introVideo);
        //     }
        // };

        const bindIntro = function () {
            if (!introSection || !introCta || !introVideo) {
                return;
            }
            introCta.addEventListener('click', function () {
                playVideo(introSection, introVideo, { reset: false });
            });
            introVideo.addEventListener('ended', function () {
                pauseVideo(introSection, introVideo, { resetTime: true });
            });
            window.addEventListener(
                'resize',
                debounce(function () {
                    if (introSection.classList.contains('is-active')) {
                        introVideo.play().catch(function () {
                            // ignore
                        });
                    }
                }, 200),
            );
        };

        const init = function () {
            bindIntro();
            bindContentsBoxes();
            // initCaptions();
        };

        return {
            init: init,
            isMobile: isMobile,
        };
    };

    const ProductSwiper = (function () {
        const instances = [];

        const getContainerWidth = function () {
            const post = document.querySelector(SELECTORS.post);
            return post ? post.clientWidth : window.innerWidth;
        };

        const needsSwiper = function () {
            return getContainerWidth() <= MOBILE_MAX;
        };

        const getSwiperOptions = function (el) {
            return {
                slidesPerView: 1,
                watchOverflow: true,
                observer: true,
                observeParents: true,
                a11y: {
                    prevSlideMessage: '이전 슬라이드',
                    nextSlideMessage: '다음 슬라이드',
                    firstSlideMessage: '첫번째 슬라이드',
                    lastSlideMessage: '마지막 슬라이드',
                    paginationBulletMessage: '{{index}}번째 슬라이드로 이동',
                },
                pagination: {
                    el: el.querySelector('.swiper-pagination'),
                    clickable: true,
                },
                navigation: {
                    nextEl: el.querySelector('.swiper-button-next'),
                    prevEl: el.querySelector('.swiper-button-prev'),
                },
            };
        };

        const create = function () {
            if (typeof Swiper === 'undefined' || !needsSwiper()) {
                return;
            }
            if (!getContainerWidth()) {
                return;
            }

            document.querySelectorAll(SELECTORS.swiper).forEach(function (el) {
                const existing = instances.find(function (swiper) {
                    return swiper.el === el;
                });

                if (existing) {
                    existing.update();
                    return;
                }

                if (el.classList.contains('swiper-initialized')) {
                    return;
                }

                instances.push(new Swiper(el, getSwiperOptions(el)));
            });
        };

        const destroy = function () {
            if (!instances.length) {
                return;
            }
            instances.forEach(function (swiper) {
                swiper.destroy(true, true);
            });
            instances.length = 0;
        };

        const toggle = function () {
            if (needsSwiper()) {
                create();
            } else {
                destroy();
            }
        };

        const bootstrap = function () {
            if (!getContainerWidth()) {
                requestAnimationFrame(bootstrap);
                return;
            }
            toggle();
        };

        const init = function () {
            bootstrap();

            const post = document.querySelector(SELECTORS.post);
            if (post && typeof ResizeObserver !== 'undefined') {
                new ResizeObserver(debounce(toggle, 200)).observe(post);
            }

            window.addEventListener('resize', debounce(toggle, 200));
            window.addEventListener('load', toggle, { once: true });
        };

        return { create: create, destroy: destroy, toggle: toggle, init: init };
    })();

    const init = function () {
        ProductSwiper.init();
        videoController().init();
    };

    if (document.readyState === 'complete' || document.readyState === 'interactive') {
        init();
    } else {
        document.addEventListener('DOMContentLoaded', init);
    }
})();
